<template>
  <div class="input-wrapper input-wrapper--payment">
    <div v-for="(option, index) in paymentOptions.options" 
      :key="`${paymentOptions.name}-${index}`" 
      class="payment-radio-item"
      :class="option.value == value  ? 'payment-radio-item--selected' : ''"
    >
      <label class="checkbox-container radio-container payment-radio-container" 
        :class="'payment-radio-container--' + option.value"
        :for="option.value" 
        :style="'background-image: url(\'/assets/payment-methods/' + option.value + '.png\')'"
      >
        <input type="radio" 
          class="payment-radio-radio" 
          :id="option.value"
          :class="option.value" 
          :name="paymentOptions.name" 
          :value="option.value"
          @change="newValue" 
          v-model="value"/>
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'payment-radios',
  data() {
    return {
      value: ""
    }
  },
  props: {
    paymentOptions: {
      type: Object,
      required: true
    }
  },
  methods: {
    newValue() {
      this.$emit('newValue', this.value)
    }   
  },
}
</script>